import React from "react"

import * as style from "./ImageFrame.module.scss"

const ImageFrame = ({
  children,
  center = false,
  shadow = false,
  border = false,
  width,
}) => (
  <span
    className={style.image}
    data-center={center === ""}
    data-shadow={shadow === ""}
    data-border={border === ""}
    data-width={width}
  >
    <span>{children}</span>
  </span>
)

export default ImageFrame
